import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapCampaignStatusResponse } from './mappers'

const campaignStatusApi = {
  fetchAsync: async (eventId) => {
    const response = await makeApiRequest(api, 'get', `/events/${eventId}/campaign_status`)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapCampaignStatusResponse(data), status }
    }
    return { error, status }
  },

  // { clientCampaignStatus, google, meta } mirrors the PUT body's own field
  // names 1:1 (google/meta pass through as-is — {campaign_status,
  // ad_group_statuses|ad_set_statuses}) so callers building overrides for a
  // single platform don't need a separate transform step. 204 on success,
  // dispatch is async — poll fetchAsync for task state.
  updateAsync: async (eventId, { clientCampaignStatus, google, meta } = {}) => {
    const body = {}
    if (clientCampaignStatus) {
      body.client_campaign_status = clientCampaignStatus
    }
    if (google) {
      body.google = google
    }
    if (meta) {
      body.meta = meta
    }

    const response = await makeApiRequest(api, 'put', `/events/${eventId}/campaign_status`, body)
    const { error, status } = unwrapEnvelope(response)
    return { error, status }
  },

  // Not part of the /campaign_status contract — separate v4 endpoints,
  // unchanged from v3 (identical route + query-param shape, in
  // both app/api/v3/events/events.py and app/api/v4/events/events.py). Kept
  // here rather than left behind in src/api/events.js because they're the
  // same "campaign-status mutator" family this module replaces from
  // eventApi. No schema/mapper needed: query-param PUT, empty 204 response.
  updateOptimisationStatusAsync: async (eventId, status) => {
    return await makeApiRequest(
      api,
      'put',
      `/events/${eventId}/campaign_optimisation_status?campaign_optimisation_status=${status}`,
    )
  },

  updateAdOptimisationStatusAsync: async (eventId, status) => {
    return await makeApiRequest(
      api,
      'put',
      `/events/${eventId}/ad_campaign_optimisation_status?ad_campaign_optimisation_status=${status}`,
    )
  },
}

export default campaignStatusApi
